(function () {
  function hideDawnQuickAddInCards() {
    document.querySelectorAll(".card-wrapper").forEach(function(card){
      if (card.querySelector(".nz-add-btn")) {
        var qa = card.querySelector(".quick-add");
        if (qa) qa.style.display = "none";
        var pf = card.querySelector(".product-form");
        if (pf) pf.style.display = "none";
      }
    });
  }

  async function addToCart(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });

    if (!res.ok) {
      let msg = "Error agregando al carrito";
      try {
        const err = await res.json();
        if (err && err.description) msg = err.description;
      } catch (e) {}
      throw new Error(msg);
    }
    return res.json();
  }

  function setBtnState(btn, state, text, icon) {
    const label = btn.querySelector(".nz-add-btn__label");
    const ico = btn.querySelector(".nz-add-btn__icon");
    if (label && text) label.textContent = text;
    if (ico && icon) ico.textContent = icon;

    btn.classList.remove("is-loading", "is-added");
    if (state) btn.classList.add(state);
  }

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("button.nz-add-btn");
    if (!btn) return;

    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    if (btn.classList.contains("is-loading")) return;

    try {
      setBtnState(btn, "is-loading", "Agregando...", "⏳");
      btn.disabled = true;

      await addToCart(variantId);

      setBtnState(btn, "is-added", "Agregado", "✓");
      setTimeout(function () {
        // vuelve al texto normal (sin fastidiar al usuario)
        btn.disabled = false;
        setBtnState(btn, "", "Agregar al carrito", "＋");
      }, 1400);
    } catch (err) {
      setBtnState(btn, "", "Error", "!");
      setTimeout(function () {
        btn.disabled = false;
        setBtnState(btn, "", "Agregar al carrito", "＋");
      }, 1400);
    }
  }, { passive: true });

  document.addEventListener("DOMContentLoaded", function(){
    hideDawnQuickAddInCards();
  });

  // por si hay cargas dinámicas (secciones)
  window.addEventListener("shopify:section:load", function(){
    hideDawnQuickAddInCards();
  });
})();
